//3rd party Imports
import React, { useEffect, useState, Suspense } from 'react';
import store, { RootState } from 'store';
import { useSelector } from 'react-redux';
import { DatePicker } from 'antd';
import styled from 'styled-components';

//Local Imports
import MyCampaigns from './MyCampaigns';
import CampaignSearch from './CampaignSearch';
import ButtonRightIconGreen from 'modules/Common/Components/ButtonRightIconGreen';
import PlusIcon from '../../../assets/img/CuratedContent/Plus.svg';
import PlusGreen from '../../../assets/img/CuratedContent/Plus-Green.svg';
import CreateAsset from '../CampaignAssets/Components/CreateAsset';
import { getCampaignList, getCampaignsDashboardGraphData, getUsersDataFilters } from '../CampaignAssets/actions';
import CreateCampaign from 'modules/Campaigns/CampaignAssets/Components/CreateCampaign';
import StickyHeader from 'modules/Common/Components/StickyHeader';
import StickyHeaderContent from 'modules/Common/Components/StickyHeaderContent';
import SelectWithIcon from '../Shared/SelectWithIcon';
import CustomChart from '../Shared/CustomChart';
import EngagementChart from 'modules/Content/Shared/EngagementChart';
import ToggleView from 'modules/Common/Components/ToggleView';
import MostEngaged from 'modules/Common/Components/MostEngaged';
import ButtonRightIcon from 'modules/Common/Components/ButtonRightIcon';
import { ReactComponent as Campaign } from '../../../assets/img/icons/Digest-email.svg';
import { ReactComponent as People } from '../../../assets/img/icons/Campaign/People.svg';
import { ReactComponent as Calender } from '../../../assets/img/icons/Campaign/Calender.svg';
import { ReactComponent as Triangle } from '../../../assets/img/icons/Triangle.svg';
import { ReactComponent as Diamond } from '../../../assets/img/icons/Diamond.svg';
import { useGraphDataScaler } from '../Shared/useGraphDataScaler';
import { TextContainer } from '../AdHocEmail/PalletButtonSection';
import { getDay, getMonthDates, getQuarterDates, getWeekDates } from 'utils';
import { resetAllData } from '../utils';
import { CAMPAIGNS_LIST } from 'constants/types';

const AssetsWithoutCampaigns = React.lazy(() => import('../AssetsWithOutCampaigns/Components/AssetsWithoutCampaigns'));

const CampaignAssetsV2: React.FC = (props) => {
  const reset: boolean = useSelector((state: RootState) => state.campaigns.reset);
  const prevCampaignId: number = useSelector((state: RootState) => state.campaigns.prevCampaignId);
  const campaignsUsers: any = useSelector((state: RootState) => state.campaigns.campaignsUsers);
  const campaignsGraphData: any = useSelector((state: RootState) => state.campaignsGraphData);
  const startDate: any = useSelector((state: RootState) => state.campaignsGraphData.startDate);
  const endDate: any = useSelector((state: RootState) => state.campaignsGraphData.endDate);
  const campaignItems = useSelector((state: RootState) => state.getCampaignNames.data);
  const [isListView, setIsListView] = useState(localStorage.getItem('isListView') === 'true');
  const [graphData, setGraphData]: [any, any] = useState({});

  //Filters local state
  const [userFilter, setUserFilter] = useState({ label: 'by User', value: 'default' });
  const [dateFilter, setDateFilter] = useState({ value: 'qtr', label: '1 QTR' });
  const [datesObj, setDatesObj] = useState(datesFilterChange({ value: 'qtr', label: '1 QTR' })); // assigning the return of dates function so that on first load the dates are present
  const [emailTypes, setEmailTypes] = useState({ label: 'All Types', value: 'all' });
  const [searchFilter, setSearchFilter] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);

  let searchValue = '';

  const percentage = (num: any, den: any) => {
    const value = Math.floor((num / den) * 100);
    if (value === 0) return ((num / den) * 100).toFixed(2);
    return value;
  };

  const CreateCampaignButtonStickyHeader = (buttonLabel: string) => {
    return (
      <CreateCampaign inCreateCampaign={true} createCampaignSiderId="createCampaignSiderId">
        <ButtonRightIconGreen id="createCampaignButtonHomePage" icon={PlusIcon} label={buttonLabel} classIcon="plus15" />
      </CreateCampaign>
    );
  };
  const getGraphsData = (dates: any, user?: any) => {
    let _params: any = {};
    if (user) {
      _params.user_id = user;
    } else {
      _params.user_id = userFilter.value === 'default' ? 0 : Number(userFilter.value);
    }
    _params.start_date = dates.start_date;
    _params.end_date = dates.end_date;
    getCampaignsDashboardGraphData(_params, setGraphData);
  };

  function datesFilterChange(value: any) {
    let datesObject: any = {};

    switch (value.value) {
      case 'qtr':
        datesObject = getQuarterDates();
        break;

      case 'month':
        datesObject = getMonthDates();
        break;

      case 'week':
        datesObject = getWeekDates(7);
        break;

      case 'day':
        datesObject = getDay(2);
        break;

      default:
        break;
    }
    return datesObject;
  }

  const filteredCampaigns = (key: string, value: any, dates?: {}) => {
    let _dates: any = {};
    let _emailType: any = {};
    let _user: any = {};
    let _search: string;

    let _params: any = {};
    _params.limit = 20;
    _params.offset = 0;

    if (key === 'dates') {
      if (value.value === 'custom') {
        _dates = dates;
        setDateFilter(value);
      } else _dates = datesFilterChange(value);
    } else {
      if (dateFilter.value === 'custom') {
        _dates = dates;
      } else {
        _dates = datesFilterChange(dateFilter);
      }
    }
    setDatesObj(_dates);

    if (key === 'user') {
      setUserFilter(value);
      _user = value.value;
    } else {
      _user = userFilter.value;
    }
    if (key === 'type') {
      setEmailTypes(value);
      _emailType = value.value;
    } else {
      _emailType = emailTypes.value;
    }
    if (key === 'search' && searchFilter !== value) {
      _search = value;
      if (dates) _dates = dates;
    } else {
      _search = searchFilter;
      if (dates) _dates = dates;
    }

    if (key === 'user' || key === 'dates') {
      getGraphsData(_dates, _user);
    }
    if (_emailType !== 'all') _params.email_type = _emailType === 'aiEmail' ? 2 : _emailType === 'adhoc' ? 1 : 0;
    if (_user !== 'default') _params.user_id = _user;
    if (_search) _params.search_campaign = _search;
    // if (_dates) {
    //   _params.start_date = _dates.start_date;
    //   _params.end_date = _dates.end_date;
    // }
    if (key === 'search' || key === 'user' || key === 'type') {
      getCampaignList(_params, true);
      resetAllData(prevCampaignId);
    }
  };

  useEffect(() => {
    document.body.style.overflow = 'auto';
    if (campaignsUsers.length <= 1 || reset) {
      getUsersDataFilters();
    }
    if (Object.keys(campaignsGraphData.data).length === 0 || reset) getGraphsData(datesFilterChange({ value: 'qtr', label: '1 QTR' }));
    // if (campaignItems.length === 0) {
    //   getCampaignsNamesOnly();
    // }
    return () => {};
  }, []);

  useEffect(() => {
    if (
      emailTypes.value === 'all' &&
      userFilter.value === 'default' &&
      searchFilter === ''
      // &&
      // dateFilter.value === "qtr"
    )
      setIsFiltered(false);
    else setIsFiltered(true);
  }, [dateFilter, userFilter, emailTypes, searchFilter, datesObj, campaignsGraphData, graphData]);

  return (
    <Wrapper>
      <StickyHeader overlayClass="asset-header">
        <StickyHeaderContent label={'Campaigns & Emails'}>
          <div className="sticky-header-tabs-container">
            <div className="button-and-search-icon">{CreateCampaignButtonStickyHeader('Create New Campaign')}</div>
            <div className="button-and-search-icon">
              <CreateAsset wrapperclass={'fixed-position Popover-share-sidebar'} eventType="CAC">
                <ButtonRightIcon
                  icon={PlusGreen}
                  label="Create New Email"
                  outlineClass="green-outline"
                  classBtn="white-btn ml"
                  classIcon="white-icon plus15"
                />
              </CreateAsset>
            </div>
          </div>
        </StickyHeaderContent>
      </StickyHeader>
      <div className="campaign-main-row">
        <div className="campaign-left-col">
          <div className="d-flex justify-content-between align-items-center header-content">
            <h4>All Campaign Performance</h4>
            <ul className="select-list z-index-9">
              <li>
                <SelectWithIcon
                  id="user"
                  emoji={<People style={{ height: 18, width: 18 }} />}
                  className="by-user"
                  options={campaignsUsers}
                  value={userFilter}
                  menuWidth={255}
                  onChange={(e) => {
                    const dateParam = { ...datesObj };
                    if (dateParam.start_date === '' && dateParam.end_date === '') {
                      dateParam.start_date = startDate;
                      dateParam.end_date = endDate;
                    }
                    filteredCampaigns('user', e, dateParam);
                  }}
                />
              </li>
              <li>
                <SelectWithIcon
                  id="date"
                  emoji={<Calender style={{ height: 18, width: 18 }} />}
                  className="date-filter"
                  options={[
                    { label: '1 QTR', value: 'qtr' },
                    { label: 'Month', value: 'month' },
                    { label: 'Week', value: 'week' },
                    { label: 'Day', value: 'day' },
                    { label: 'Custom', value: 'custom' },
                  ]}
                  heightWidth={15}
                  value={dateFilter}
                  customDatePicker={<DatePicker bordered={false} />}
                  datesObj={datesObj}
                  setDatesObj={setDatesObj}
                  dateFilter={dateFilter}
                  setDateFilter={setDateFilter}
                  filteredCampaigns={filteredCampaigns}
                />
              </li>
            </ul>
          </div>
          <div id="campVsCamp" className="chart-container">
            <CustomChart title={'Campaign Performance'} useFormatedData={useGraphDataScaler} boxRightOffset={'1.3%'} />
          </div>
          <div id="myCampaignsDiv" className="d-flex justify-content-between py-4">
            <ul className="select-list d-flex justify-content-between w-100">
              <li>
                <ul>
                  <li>
                    <ToggleView isListView={isListView} setIsListView={setIsListView} />
                  </li>
                  <li>
                    <h3>My Campaigns</h3>
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="small-search">
                    <CampaignSearch
                      setSearchFilter={setSearchFilter}
                      searchFilter={searchFilter}
                      filteredCampaigns={filteredCampaigns}
                      searchValue={searchValue}
                      datesObj={datesObj}
                    />
                  </li>
                  <li className="list-dropdown-ai">
                    <SelectWithIcon
                      emoji={<Campaign style={{ height: 18, width: 18 }} />}
                      options={[
                        { label: 'All Types', value: 'all' },
                        { label: 'Ad hoc Emails', value: 'adhoc' },
                        { label: 'Digest Emails', value: 'digest' },
                        { label: 'AI Emails', value: 'aiEmail' },
                      ]}
                      value={emailTypes}
                      menuWidth={160}
                      onChange={(e) => {
                        const dateParam = { ...datesObj };
                        filteredCampaigns('type', e, dateParam);
                      }}
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          {!isFiltered && (
            <Suspense fallback={<></>}>
              <AssetsWithoutCampaigns isListView={isListView} />
            </Suspense>
          )}
          <MyCampaigns
            isListView={isListView}
            userFilter={userFilter}
            emailTypes={emailTypes}
            datesObj={datesObj}
            searchFilter={searchFilter}
            isFiltered={isFiltered}
            dateFilter={dateFilter}
          />
        </div>
        <div className="campaign-right-col">
          <div id="overallEngagment" className="d-flex flex-column justify-content-between engagement-text-container">
            <div className="engagement-chart-container">
              <EngagementChart plotData={graphData} title={'X-campaign engagement'} />
            </div>
            <div className="d-flex flex-row text-boxes w-100">
              <TextContainer
                color="#FF9531"
                width="175px"
                height="165px"
                borderRadius="10px"
                style={{ height: '165px', width: '50%', marginRight: '10px' }}
              >
                <div className="d-flex flex-column stats-container">
                  <div className="d-flex flex-row align-items-center stat-type-container">
                    {<Triangle className="icon-styling" />}
                    <span className="stat-type">Opens</span>
                  </div>
                  <div className="stats-data">
                    <span className="stats">{campaignsGraphData?.data?.unique_opens ? campaignsGraphData?.data?.unique_opens : 'NA'}</span>
                  </div>
                  <div className="d-flex justify-content-center">
                    <span className="percentage">
                      {`${percentage(campaignsGraphData?.data?.unique_opens ?? 0, campaignsGraphData?.data?.total_sent ?? 1) || 'NA'} % Open rate`}
                    </span>
                  </div>
                </div>
              </TextContainer>
              <TextContainer
                color="#27CE0A"
                width="175px"
                height="165px"
                smHeight="140px"
                borderRadius="10px"
                style={{ height: '165px', width: '50%', marginLeft: '10px' }}
              >
                <div className="d-flex flex-column stats-container">
                  <div className="d-flex flex-row align-items-center stat-type-container">
                    {<Diamond className="icon-styling" />}
                    <span className="stat-type">Clicks</span>
                  </div>

                  <div className="stats-data">
                    <span className="stats">{campaignsGraphData?.data?.unique_clicks ? campaignsGraphData?.data?.unique_clicks : 'NA'}</span>
                  </div>
                  <div className="d-flex justify-content-center">
                    <span className="percentage">
                      {`${percentage(campaignsGraphData?.data?.unique_clicks ?? 0, campaignsGraphData?.data?.total_sent ?? 1) || 'NA'} % Click rate`}
                    </span>
                  </div>
                </div>
              </TextContainer>
            </div>
          </div>
          <div className="most-engaged-styling">
            <MostEngaged
              title="Most engaged companies:"
              Square={true}
              data={campaignsGraphData?.data?.most_engaged_companies}
              message="No Companies found."
            />
            <div className="mt-5">
              <MostEngaged title="Most engaged contacts:" data={campaignsGraphData?.data?.most_engaged_contacts} message="No contacts found." />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default CampaignAssetsV2;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  .campaign-main-row {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    .campaign-left-col {
      width: 72%;
      padding-top: 20px;
      padding-right: 60px;
      .header-content {
        margin-bottom: 12px;
      }
      h4 {
        color: #001823;
        font-size: 26px;
        font-family: 'Roboto Slab', serif;
        padding: 0;
        margin: 0;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 18px;
        }
      }
      ul.select-list,
      ul.select-list ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        &.z-index-9 {
          div[class$='-container'] {
            z-index: 8 !important;
          }
        }
        .search-bar {
          @media all and (min-width: 1024px) and (max-width: 1280px) {
            height: 34px;
            min-height: 34px;
          }
          .clear-search {
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              margin: auto 8px;
            }
          }
        }
        li {
          margin: 5px 5px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            margin: 5px 3px;
          }
          div[class$='-control'] {
            width: 150px;
            @media all and (max-width: 1024px) {
              width: 100px;
            }
            @media all and (max-width: 1439px) {
              width: 125px;
            }
          }
          .list-view {
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              min-width: 36px;
              width: 36px;
              height: 30px;
              border-top-left-radius: 6px;
              border-bottom-left-radius: 6px;
              img {
                width: 18px;
              }
            }
          }
          .card-view {
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              min-width: 36px;
              width: 36px;
              height: 30px;
              border-top-right-radius: 6px;
              border-bottom-right-radius: 6px;
              img {
                width: 18px;
              }
            }
          }
          h3 {
            font-size: 22px;
            color: #67696a;
            font-weight: 500;
            font-family: 'robotomedium';
            margin: 6px 10px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 16px;
            }
          }
          &.small-search {
            width: 320px;
            @media all and (max-width: 1439px) {
              width: 185px;
            }
            + li div[class$='-control'] {
              max-width: 160px;
              width: 160px;
            }
          }
        }
      }
      .chart-container {
        width: 100%;
        height: inherit;
        max-height: 415px !important;
        @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
          max-height: 350px !important;
        }
        > div {
          height: 415px !important;
          z-index: 7;
          @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
            max-height: 350px !important;
          }
        }
      }
    }
    .campaign-right-col {
      width: 28%;
      padding: 100px 20px 0 0;
      background: rgb(238, 238, 238);
      background: linear-gradient(-63deg, rgba(238, 238, 238, 1) 0%, rgba(216, 216, 216, 1) 100%);
      #overallEngagment {
        margin-left: -45px;
        .engagement-chart-container {
          margin-bottom: 20px;
          height: 230px;
          @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
            height: 190px;
          }
        }
        .text-boxes > div {
          @media all and (max-width: 1439px), (-webkit-device-pixel-ratio: 1.25) {
            height: 140px !important;
          }
        }
      }
      .most-engaged-styling {
        margin-top: 70px;
      }
    }
  }
  .search-icon-container {
    cursor: pointer;
    padding: 5px 0 5px 25px;
    @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 5px 0 5px 12px;
    }
  }
  .button-and-search-icon {
    align-items: inherit;
    display: flex;
    justify-content: space-between;
    padding: 1em 0 1.5em 5px;
    @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
      padding-bottom: 12px;
    }
    button {
      padding-top: 3px;
      padding-bottom: 3px;
      @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
        padding-top: 0px;
        padding-bottom: 0px;
      }
    }
  }
  .sticky-header-tabs-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* justify-content: space-evenly; */
  }
  .heading-campaign {
    font-size: 22px;
    color: #67696a;
    font-weight: 500;
    font-family: 'Roboto', sans-serif;
    margin-bottom: 20px;
    margin-top: 50px;
  }
  h2 {
    color: #424b50;
    font-size: 40px;
    font-weight: 600;
    line-height: 47px;
    margin-bottom: 0px;
    display: block;
    font-family: 'Roboto Slab', serif;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 28px;
      line-height: 33px;
    }
  }
  .head-wrapper {
    display: flex;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn-wrapper {
      display: flex;
      align-items: center;
      .ml {
        margin-left: 12px;
      }
    }
  }
  .asset-name {
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    float: left;
    max-width: 700px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-width: 445px;
    }
  }
  .name {
    color: rgb(155, 155, 155);
    position: relative;
    float: left;
    display: flex;
    align-items: center;

    .tooltip {
      position: relative;
      display: inline-block;
      opacity: 1;
      z-index: 0;
      .tooltiptext {
        color: #ffffff;
        font-size: 11px;
        letter-spacing: 0.02px;
        line-height: 15px;
        text-align: center;
        background-color: #263153;
        visibility: hidden;
        border-radius: 4px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 0.3s;
        padding: 5px 10px;
        &:after {
          content: '';
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #263153 transparent transparent transparent;
        }
      }
      &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
    }
    .asset-name {
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      float: left;
      max-width: 700px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: 445px;
      }
    }
    &.editable-active {
      .editable {
        display: block;
        min-width: 320px;
      }
    }
    .editable {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      display: none;
      label {
        display: none;
      }
      input {
        padding-right: 70px;
      }
      .save {
        position: absolute;
        top: 9px;
        right: 10px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
        }
      }
      .cancel {
        position: absolute;
        top: 9px;
        right: 40px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
        }
      }
    }
    .edit-btn {
      cursor: pointer;
      margin-left: 10px;
    }
  }
  .scroll-Wrapper {
    height: auto;
    overflow-x: hidden;
    @media all and (max-height: 780px) {
      max-height: 315px;
    }
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      display: none;
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .add-words-wrapper {
    .wrapper-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .add-word-head {
        color: #5e7079;
        font-size: 20px;
        margin-bottom: 0px;
        font-family: 'Roboto', sans-serif;
        font-weight: 600;
        display: inline-block;
        letter-spacing: -0.5px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 14px;
        }
      }
      .sub-text {
        font-size: 14px;
        margin-left: 3px;
        font-weight: 600;
        opacity: 0.4;
        color: rgba(0, 0, 0, 0.85);
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
        }
      }
      .test {
        font-weight: bold;
        font-size: 12px;
        color: #27ce0a;
        border: 1px solid #27ce0a;
        padding: 2px 8px;
        border-radius: 6px;
        cursor: pointer;
        letter-spacing: 1px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 9px;
          border-radius: 4px;
        }
      }
    }
    .search-input {
      padding: 10px 18px;
      font-size: 16px;
      line-height: 20px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
        line-height: 16px;
        padding: 5px 10px;
        border-radius: 6px;
      }
    }
    .dec-paragraph {
      color: #5e7079;
      font-size: 14px;
      margin-bottom: 0px;
      font-family: 'Roboto', sans-serif;
      font-weight: 600;
      margin-top: 10px;
      opacity: 0.6;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 10px;
      }
      &.mb {
        margin-bottom: 10px;
      }
    }
  }
  .horizontal-space-between {
    justify-content: space-between;
  }
`;
